import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/routers.js";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap";
import "@/assets/sass/main.css";
import { createPinia } from "pinia";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
const app = createApp(App);
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_APP_ID,
  measurementId: process.env.VUE_APP_MEASUREMENT_ID
};

initializeApp(firebaseConfig);
app.config.productionTip = false;
import { getDatabase, ref, onValue } from "firebase/database";

const db = getDatabase();
onValue(ref(db), (snapshot) => {
  localStorage.setItem("productData", JSON.stringify(snapshot.val()));
});

import Swal from "sweetalert2";
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

export default Toast;

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
/* add icons to the library */
library.add(fas);
app.component("fa", FontAwesomeIcon);

app.use(createPinia());
app.use(VueSweetalert2);
app.use(router);
app.mount("#app");
